import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ChangeDetectorRef
} from "@angular/core";
import { Order } from "src/app/core/models/order";
import {
  MdbTableDirective,
  MDBModalService,
  MDBModalRef
} from "ng-uikit-pro-standard";
import { AuthService, FirebaseService } from "src/app/core";
import { ConfirmRedeemComponent } from "src/app/shared/components/popups/confirm-redeem/confirm-redeem.component";
import { ProductType } from 'src/app/core/product/enums';

@Component({
  selector: "ll-orders-table",
  templateUrl: "./orders-table.component.html",
  styleUrls: ["./orders-table.component.scss"]
})
export class OrdersTableComponent implements OnInit {
  modalRef: MDBModalRef;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;

  constructor(
    public fb: FirebaseService,
    public auth: AuthService,
    private modalService: MDBModalService
  ) {}
  get data() {
    return this.fb.orders.filter.filtered;
  }
  get filter() {
    return this.fb.orders.filter;
  }

  get items() {
    return this.data.map(order => order.items[0]);
  }

  ngOnInit() {
    this.mdbTable.setDataSource(this.data);
  }

  getType(i: number): string {
    return ProductType[i];
  }
  setItemsPerPage(item: number) {
    this.filter.showing = item;
    this.filter.firstIndex = 0;
    this.filter.lastIndex = item;
    this.mdbTable.setDataSource(this.data);
  }

  show(i: number) {
    return this.filter.show(i);
  }
  increment() {
    this.filter.increment();
  }
  decrement() {
    this.filter.decrement();
  }
  redeem(order: Order) {
    this.modalRef = this.modalService.show(ConfirmRedeemComponent, {
      ignoreBackdropClick: true,
      class: "modal-dialog-centered",
      containerClass: "center",
      animated: true,
      data: {
        description:
          order.items[0].summary.redeemedAt == null
            ? "Are you sure you want to redeem this order?"
            : "Are you sure you want to un-redeem this order?"
      }
    });
    this.modalRef.content.action.subscribe((result: boolean) => {
      if (result) {
        order.items[0].summary.redeemedAt == null
          ? this.fb.orders.redeem(order)
          : this.fb.orders.unredeem(order);
      }
    });
  }

  mailTo(email: string) {
    return "mailto:" + email;
  }

  get isAdmin() {
    return this.auth.admin;
  }

  mask(email: string) {
    if (!email.includes("@")) return email;
    let x = email.split("@");
    return x[0] + "@" + "*".repeat(x[1].length - 1);
  }
}
